/**
 * PerformanceScoreCard - Displays performance scores with visual indicators
 */

import React from "react";
import {Card, CardBody, Progress} from "reactstrap";
import {PerformanceScore} from "../../types/advancedAnalysis";

interface PerformanceScoreCardProps {
  score: PerformanceScore;
}

const getScoreColor = (score: number): string => {
  if (score >= 90) {
    return "success";
  }
  if (score >= 75) {
    return "info";
  }
  if (score >= 60) {
    return "warning";
  }
  return "danger";
};

const PerformanceScoreCard: React.FC<PerformanceScoreCardProps> = ({score}) => {
  return (
    <Card>
      <CardBody>
        <h5 className="card-title">Performance Score</h5>
        <div className="text-center mb-4">
          <div style={{fontSize: "3rem", fontWeight: "bold", color: `var(--${getScoreColor(score.Overall)})`}}>
            {score.Overall}
            <small style={{fontSize: "1.5rem"}}>/100</small>
          </div>
        </div>

        <div className="mb-3">
          <div className="d-flex justify-content-between mb-1">
            <span>
              <i className="fa fa-desktop mr-2"></i>
              Graphics
            </span>
            <span className="font-weight-bold">{score.Graphics}</span>
          </div>
          <Progress value={score.Graphics} color={getScoreColor(score.Graphics)} />
        </div>

        <div className="mb-3">
          <div className="d-flex justify-content-between mb-1">
            <span>
              <i className="fa fa-wifi mr-2"></i>
              Network
            </span>
            <span className="font-weight-bold">{score.Network}</span>
          </div>
          <Progress value={score.Network} color={getScoreColor(score.Network)} />
        </div>

        <div className="mb-3">
          <div className="d-flex justify-content-between mb-1">
            <span>
              <i className="fa fa-heartbeat mr-2"></i>
              Sensors
            </span>
            <span className="font-weight-bold">{score.Sensors}</span>
          </div>
          <Progress value={score.Sensors} color={getScoreColor(score.Sensors)} />
        </div>

        <div className="mb-3">
          <div className="d-flex justify-content-between mb-1">
            <span>
              <i className="fa fa-microchip mr-2"></i>
              Hardware
            </span>
            <span className="font-weight-bold">{score.Hardware}</span>
          </div>
          <Progress value={score.Hardware} color={getScoreColor(score.Hardware)} />
        </div>
      </CardBody>
    </Card>
  );
};

export default PerformanceScoreCard;
